export class RoleMetierDto {
  constructor(
    public code?: string,
    public libelle?: string,
    public libelleLong?: string,
    public libelleCourt?: string,
    public libellePluriel?: string,
    public priorite?: number,
  ) { }
}

export enum RoleMetier {
  GEST_PROD = 'GEST_PROD',
  MANDATAIRE = 'MANDATAIRE',
  REPRESENTANT_LEGAL = 'REPRESENTANT_LEGAL',
  DELEGUE = 'DELEGUE',
  SUIVI_PARC_PRODUITS_CONSULTATION = 'SUIVI_PARC_PRODUITS_CONSULTATION',
  GESTIONNAIRE_INCIDENT = 'GESTIONNAIRE_INCIDENT',
  SUPPLEANT_PFCNG = 'SUPPLEANT_PFCNG',
  GEST_TRACE_FONCTIONNELLE = 'GEST_TRACE_FONCTIONNELLE',
  GEST_HABILITATION_ASIP = 'GEST_HABILITATION_ASIP',
  OPERATEUR_SUPPORT_PFCNG = 'OPERATEUR_SUPPORT_PFCNG',
  GGIP = 'GGIP',
  SUPPORT = 'SUPPORT',
  SUP_GEST = 'SUP_GEST',
  GAE_TOUTE_STRUCTURE = 'GAE_TOUTE_STRUCTURE',
  GAE = 'GAE',
  GARS = 'GARS',
  DELEGUE_GENERIQUE = 'DELEGUE_GENERIQUE',
  GEST_PROD_GENERIQUE = 'GEST_PROD_GENERIQUE'
}
